import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';

import { fetchBudgetRequests } from '../../store/actions/projects/requestBudgetHoursActions';

class BudgetedHoursRequests extends Component {

  componentDidMount() {
    this.props.fetchBudgetRequests();
  }

  renderBudgetRequests = () => {
    const budgetRequests = this.props.budgetRequests.budgetRequests;

    let budgetRequestsList = [];

    if (budgetRequests) {
      budgetRequestsList = budgetRequests.length ? (
        budgetRequests.map((budgetRequest, key) => {
          let projectName = '';
          let requestorName = '';
          let duration = '';
          let reason = '';

          if (budgetRequest.user_details) {
            const user = budgetRequest.user_details;
            if (user) {
              requestorName = user.first_name + " " + user.last_name;
            }
          }

          if (budgetRequest.project_details) {
            const project = budgetRequest.project_details;
            if (project) {
              projectName = project.project_name;
            }
          }

          duration = budgetRequest.duration;
          reason = budgetRequest.reason;

          return (
            <tr key={key}>
              <td>{requestorName}</td>
              <td>{projectName}</td>
              <td className="align-center">{duration}</td>
              <td>{reason}</td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td>Loading..</td>
        </tr>
      )
    }
    else {
      budgetRequestsList = (
        <tr>
          <td><span className="text-danger">No results found.</span></td>
        </tr>
      )
    }

    return budgetRequestsList;
  }

  render() {
    return (
      <Table>
        <thead>
          <tr>
            <th className="align-center">Requestor</th>
            <th className="align-center">Project Name</th>
            <th className="align-center">Requested Hours</th>
            <th className="align-center">Reason</th>
          </tr>
        </thead>
        <tbody>
          { this.renderBudgetRequests() }
        </tbody>
      </Table>
    )
  }
}

const mapStateToProps = (state) => ({
  budgetRequests: state.budgetRequests
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBudgetRequests: () => dispatch(fetchBudgetRequests())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetedHoursRequests)
